import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import Sidebar from "../Sidebar/Sidebar";
import FooterElement from "../../Components/footer/FooterElement";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";

const WelcomePage = () => {
  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  const [updates, setUpdates] = useState([]);
  const [resolvedIssues, setResolvedIssues] = useState([]);

  useEffect(() => {
    // Mock data for updates
    const mockUpdates = [
      {
        id: 1,
        title: "Credit Note Excel Export",
        description:
          "An Excel download button has been added to the Credit Note screen. Users can now export Excel files for 'Against Bill: YES' Credit Notes.",
      },
      {
        id: 2,
        title: "Normal Credit Note Display Issue",
        description:
          "Resolved the issue where the 'Normal Credit Note' option appeared as 'undefined' in the Credit Note view mode.",
      },
      {
        id: 3,
        title: "Stock Transfer Short/Excess Access",
        description:
          "The Stock Transfer Short/Excess module is now available to users upon request and with admin approval.",
      },
      {
        id: 4,
        title: "Mandatory Cheque Number in Money Receipts",
        description:
          "Implemented validation to ensure that Money Receipts cannot be saved without a cheque number when 'Cheque' mode is selected.",
      },
      {
        id: 5,
        title: "Warranty and Warranty Return Enhancements",
        description:
          "Users can now add multiple entries with the same Part Number in the Warranty module. The Serial Number (SRL) is now used as the unique identifier for items.",
      },
    ];

    // Mock data for resolved issues
    const mockResolvedIssues = [
      {
        id: 1,
        title: "Bill Outstanding",
        resolution: "We are resolving the billoutstanding issue.",
      },
      {
        id: 2,
        title: "Filter customers with no orders in salebill",
        resolution: "We will be fixing this issue soon.",
      },
    ];

    setUpdates(mockUpdates);
    setResolvedIssues(mockResolvedIssues);
  }, []);

  return (
    <div>
      <Sidebar
        Title="WELCOME"
        expandedPanel="panel2"
        children={
          <>
            <Box p={3}>
              <Typography variant="h5" gutterBottom>
                Development Updates - 29/04/2025
              </Typography>
              <List>
                {updates.map((update) => (
                  <ListItem key={update.id}>
                    <ListItemText
                      primary={update.title}
                      secondary={update.description}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
            <Box p={3}>
              <Typography variant="h5" gutterBottom>
                Upcoming Updates
              </Typography>
              <List>
                {resolvedIssues.map((issue) => (
                  <ListItem key={issue.id}>
                    <ListItemText
                      primary={issue.title}
                      secondary={issue.resolution}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
            <FooterElement />
            {redirectToLoginPage()}
          </>
        }
      />
    </div>
  );
};

export default WelcomePage;
